import { useAction } from '@reatom/npm-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Result } from '@blade/std-lib'
import { useHapticFeedback } from '@blade/ui-kit'
import { WalletAddress } from '@root/entities/wallet'
import { startScanQrFlowEvent } from '@root/features/services/scan-qr/atoms'
import { ScanIcon, WalletIcon } from '@root/shared/ui-kit'

type Props = {
  value: string
  onChange: (address: WalletAddress) => void
  onWalletClick: () => void
}

export const TransferCardAddressInput: React.FC<Props> = ({
  onChange,
  onWalletClick,
  value,
}) => {
  const { t } = useTranslation()
  const haptics = useHapticFeedback()
  const startScanQr = useAction(startScanQrFlowEvent)

  const handleScan = async () => {
    haptics.impactOccurred('light')
    startScanQr({
      onScanned: (address) => {
        if (Result.isSuccess(address)) {
          haptics.impactOccurred('light')
          onChange(address.success)
        }
      },
    })
  }

  return (
    <Root>
      <Input
        placeholder={t('wallet.address_input_placeholder')}
        value={value}
        onChange={(e) => onChange(WalletAddress(e.target.value))}
      />
      <ScanContainer onClick={handleScan} type="button">
        <ScanIcon />
      </ScanContainer>
      <EndContent
        onClick={() => {
          haptics.impactOccurred('light')
          onWalletClick()
        }}
        type="button"
      >
        <WalletIcon />
      </EndContent>
    </Root>
  )
}

const Root = styled.div`
  height: 48px;

  border-radius: 12px;
  background: var(--appearance-1);

  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  padding-inline: 16px 0;
`

const Input = styled.input`
  width: 100%;
  height: 100%;
  padding-inline: 0;
  outline: none;
  border: none;
  background: transparent;

  color: var(--text-12);
  font-size: var(--typography-body-2-regular-font-size);
  font-weight: var(--typography-body-2-regular-font-weight);
  line-height: var(--typography-body-2-regular-line-height);

  &::placeholder {
    color: var(--text-9);
  }
`

const ScanContainer = styled.button`
  all: unset;
  cursor: pointer;
  display: grid;
  align-items: center;
  height: 100%;
  padding-inline: 12px;
  transition: all 0.3s ease;
  &:hover {
    color: var(--text-11);
  }
`

const EndContent = styled.button`
  all: unset;
  cursor: pointer;
  height: 100%;
  display: grid;
  align-items: center;
  transition: all 0.3s ease;

  border-inline-start: 1px solid var(--backgroundA-3);
  padding-inline: 12px;

  &:hover {
    color: var(--text-11);
  }
`
